import React from 'react';
import Icon, { SIZES as ICON_SIZES } from '../../../FontIcon';
export var calendarIconElement = /*#__PURE__*/React.createElement(Icon, {
  size: ICON_SIZES.S
}, "icon-calendar");